export default "__VITE_ASSET__nEUD7Vs5__";